import React from "react";

import Street from "./street";

const Streets = ({ showStreets, setFieldsValue, companyId }) => {
	if (!showStreets) {
		return null;
	}
	return showStreets.map((streetObj) => {
		return (
			<Street
				key={streetObj.streetId}
				setFieldsValue={setFieldsValue}
				streetObj={streetObj}
				companyId={companyId}
			/>
		);
	});
};

export default Streets;
